/* tslint:disable */
/* eslint-disable */
/**
 * SEC AUDITOR API
 * Mehr unter https://sec-auditor.com
 *
 * The version of the OpenAPI document: 4.5.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Successful response
 * @export
 * @interface CreateClientAsAdmin201Response
 */
export interface CreateClientAsAdmin201Response {
    /**
     * 
     */
    message: string;
    /**
     * 
     */
    uuid?: string;
}

/**
 * Check if a given object implements the CreateClientAsAdmin201Response interface.
 */
export function instanceOfCreateClientAsAdmin201Response(value: object): value is CreateClientAsAdmin201Response {
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function CreateClientAsAdmin201ResponseFromJSON(json: any): CreateClientAsAdmin201Response {
    return CreateClientAsAdmin201ResponseFromJSONTyped(json, false);
}

export function CreateClientAsAdmin201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateClientAsAdmin201Response {
    if (json == null) {
        return json;
    }
    return {
        
        'message': json['message'],
        'uuid': json['uuid'] == null ? undefined : json['uuid'],
    };
}

export function CreateClientAsAdmin201ResponseToJSON(json: any): CreateClientAsAdmin201Response {
    return CreateClientAsAdmin201ResponseToJSONTyped(json, false);
}

export function CreateClientAsAdmin201ResponseToJSONTyped(value?: CreateClientAsAdmin201Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'message': value['message'],
        'uuid': value['uuid'],
    };
}

